module.exports = __webpack_public_path__ + "img/post_bg.c2d8d22c.png";